let css = require('./action-panel.css');
let { cut } = require('../../../../helpers/utils');
let utils = require('../../../../signals/utils');
let signals = require('../../../../signals/account/statistic');
let preloader = require('../../../layout/preloader');

class ActionPanel {
    constructor () {
        this.template = require('./template.hbs');
    }

    bind () {
        return {
            click: {
                [cut(css.redirect)]: this.redirect,
                [cut(css.switchModeButton)]: this.switchModeButton,
                [cut(css.downloadExcel)]: this.downloadExcel
            }
        };
    }

    render () {
        let props = this.$context.props;
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, props, { css }));
    }

    switchModeButton (e) {
        e.stopPropagation();
        this.$context.signal(signals.switchCityBranchMode);
    }

    redirect (e) {
        e.stopPropagation();
        let url = e.currentTarget.getAttribute('cat-url');
        this.$context.signal(utils.redirect, { url: url });
    }

    downloadExcel (e) {
        e.stopPropagation();
        this.$context.signal(signals.downloadExcel);
    }
}

module.exports = {
    constructor: ActionPanel,
    children: [
        {
            name: 'preloader',
            component: preloader,
            props: {
                size: 'big'
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/account/statistic/action-panel/index.js